import { Reveal, SectionHeading } from "@/components/Reveal";
import { TIMELINE } from "@/data/content";

export default function Experience() {
  return (
    <section id="experience" data-testid="experience-section" className="border-t border-white/5 bg-[#0A0A0A] py-24 lg:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <SectionHeading
          label="Experience"
          title="Built on stages,"
          accent="proven under pressure"
          description="A career spent behind consoles and inside racks — from Dubai's longest-running live venues to the region's biggest arenas and exhibitions."
          testId="experience-heading"
        />

        <ol className="relative ml-3 border-l border-white/10 lg:ml-6" data-testid="experience-timeline">
          {TIMELINE.map((job, i) => (
            <li key={`${job.company}-${job.period}`} className="relative pb-14 pl-10 last:pb-0 lg:pl-14">
              <span
                className={`absolute -left-[7px] top-1.5 h-3.5 w-3.5 rounded-full border-2 ${
                  job.current ? "border-electric bg-electric shadow-[0_0_16px_rgba(255,140,0,0.7)]" : "border-neutral-600 bg-[#0A0A0A]"
                }`}
                aria-hidden="true"
              />
              <Reveal delay={0.05 * i}>
                <div className={`rounded-2xl border p-6 transition-[border-color,transform] duration-300 hover:-translate-y-1 lg:p-8 ${
                  job.current ? "border-electric/30 bg-electric/[0.04]" : "border-white/10 bg-white/[0.02]"
                }`}>
                  <div className="flex flex-wrap items-start justify-between gap-3">
                    <div>
                      <p className="text-[10px] font-bold uppercase tracking-[0.25em] text-neutral-500">{job.period} · {job.location}</p>
                      <h3 className="mt-2 font-display text-2xl font-semibold uppercase tracking-tight text-neutral-100">{job.role}</h3>
                      <p className="mt-1 text-sm font-semibold uppercase tracking-[0.1em] text-electric">{job.company}</p>
                    </div>
                    {job.current && (
                      <span className="rounded-full border border-electric/40 bg-electric/10 px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.2em] text-electric">
                        Current
                      </span>
                    )}
                  </div>
                  <p className="mt-4 max-w-3xl text-sm leading-relaxed text-neutral-400 sm:text-base">{job.description}</p>
                  {job.productions && (
                    <div className="mt-6">
                      <p className="mb-3 text-[10px] font-bold uppercase tracking-[0.25em] text-neutral-500">Selected productions</p>
                      <div className="flex flex-wrap gap-2">
                        {job.productions.map((p) => (
                          <span key={p} className="rounded-full border border-white/10 bg-black/40 px-3 py-1.5 text-[11px] font-semibold text-neutral-300 transition-colors duration-300 hover:border-electric/50 hover:text-electric">
                            {p}
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </Reveal>
            </li>
          ))}
        </ol>
      </div>
    </section>
  );
}
